import './Login.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { faAt, faPhone, faLock } from '@fortawesome/free-solid-svg-icons';
import Navbar from '../UI/Navbar';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useUserAuth } from '../../context/UserAuthContext';
import ErrorModal from '../UI/ErrorModal';
import GLogin from '../../assets/GLogin.png';

const Signup = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [contact, setContact] = useState('');
  const { signUp, logInWithGoogle } = useUserAuth();
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const authErrorCodesToMsgs = (errorCode) => {
    switch (errorCode) {
      case "auth/email-already-exists":
        return "The provided email is already in use by an existing user.";
      case "auth/invalid-email":
        return "The provided email is invalid! Enter valid email.";
      case "auth/invalid-password":
        return "The password is invalid. It must be a string with at least six characters.";
      case "auth/weak-password":
        return "The password is invalid. It must be a string with at least six characters.";
      case "auth/email-already-in-use":
        return "The provided email is already in use by an existing user.";
      default:
        return errorCode;
    }
  }

  const submitHandler = async (event) => {
    event.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      setName('');
      setEmail('');
      setPassword('');
      setContact('');
      setConfirmPassword('');
      return setError("Passwords does not match");
    }
    try {
      await signUp(email, password);
      navigate("/login");
    }
    catch (err) {
      setError(authErrorCodesToMsgs(err.code));
    }
    console.log(error);
    setName('');
    setEmail('');
    setPassword('');
    setContact('');
    setConfirmPassword('');
  }

  const googleLoginHandler = async () => {
    setError('');
    try {
      await logInWithGoogle();
      navigate("/home");
    }
    catch (err) {
      setError(authErrorCodesToMsgs(err.code));
    }
  }

  return (
    <body>
      <Navbar />
      <div className="signup-main-container">
        <div className="login-intro-container">
          <div className="login-heading">
            <h1>DISCOVER</h1>
            <h1>YOUR</h1>
            <h1>CHOSEN</h1>
            <h1>NICHE</h1>
          </div>
          <div className="login-para">
            <p>An ideal destination to uncover the path for the domain you adore!!!!</p>
          </div>
        </div>
        <form className='signup' onSubmit={submitHandler}>
          <h3>Sign Up</h3>
          <div className='Name'>
            <label>Full Name</label>
            <div className='inputDiv'>
              <FontAwesomeIcon className='faicon' icon={faUser} style={{ color: "#000000", }} />
              <input type='text' onChange={(e) => { setName(e.target.value) }} value={name} />
            </div>
          </div>
          <div className='Email'>
            <label>Email Id</label>
            <div className='inputDiv'>
              <FontAwesomeIcon className='faicon' icon={faAt} style={{ color: "#000000", }} />
              <input type='email' onChange={(e) => { setEmail(e.target.value) }} value={email} />
            </div>
          </div>
          <div className='Password'>
            <label>Password</label>
            <div className='inputDiv'>
              <FontAwesomeIcon className='faicon' icon={faLock} style={{ color: "#000000", }} />
              <input type='password' onChange={(e) => { setPassword(e.target.value) }} value={password} />
            </div>
          </div>
          <div className='ConfirmPassword'>
            <label>Confirm Password</label>
            <div className='inputDiv'>
              <FontAwesomeIcon className='faicon' icon={faLock} style={{ color: "#000000", }} />
              <input type='password' onChange={(e) => { setConfirmPassword(e.target.value) }} value={confirmPassword} />
            </div>
          </div>
          {/* <div className='Contact'>
            <label>Contact</label>
            <div className='inputDiv'>
              <FontAwesomeIcon className='faicon' icon={faPhone} style={{ color: "#000000", }} />
              <input type='text' onChange={(e) => { setContact(e.target.value) }} value={contact} />
            </div>
          </div> */}
          <button type='submit' className='Submit-btn'>Sign Up</button>
          <p className='login-signup-p'>Already have an account? <Link to='/login'>Login</Link></p>
          <h4 className='OR'>OR</h4>
          <img src={GLogin} alt='GLogin' className='GLogin-btn' onClick={googleLoginHandler} />
        </form>
        <ErrorModal errorMsg={error} isError={error} />
      </div>
    </body>
  );
}

export default Signup;